import DashboardSection from "./DashboardSection";

import "./CoachWorkload.css";

export default function CoachWorkload({ items = [] }) {
  return (
    <DashboardSection title="Coach workload" description="Trajecten per coach.">
      <div className="coach-workload">
        {items.length === 0 ? (
          <div className="coach-workload__empty">Geen coachgegevens.</div>
        ) : (
          items.map((item, index) => (
            <div key={index} className="coach-workload__row">
              <div>
                <strong>{`${item.first_name} ${item.last_name}`}</strong>

                <span>{item.coach?.email || item.email || "-"}</span>
              </div>

              <strong>{item.count}</strong>
            </div>
          ))
        )}
      </div>
    </DashboardSection>
  );
}
